import { useMutation } from "@apollo/client";
import { UPDATE_TRIP } from "../graphQl/TripPublicationAPI";

const withAuthorization = (accessToken) => ({
  headers: {
    authorization: accessToken ? `Bearer ${accessToken}` : "",
  },
});

export const useEditTrip = (accessToken = "") => {
  const [updateTripMutation, { loading, error }] = useMutation(UPDATE_TRIP);

  const updateTrip = async (tripId, tripInput) => {
    const res = await updateTripMutation({
      variables: { tripId, tripInput },
      context: withAuthorization(accessToken),
    });

    return {
      data: res.data?.MT_UPDATE_TRIP?.data || null,
      error: res.data?.MT_UPDATE_TRIP?.error || null,
    };
  };

  return {
    updateTrip,
    loading,
    error,
  };
};
